<div class="login-wrapper">
  <div class="splash-screen">
    <img class="splash-logo" src="assets/media/hamptons/Logo-english-secondary.svg" />
    <div class="splash-accent"></div>
  </div>

  <div class="login-container">
    <div class="canvas-wrapper">
      <div class="photo-layer">
        <img class="photo-image" [src]="photo$|async" />
      </div>
      <div class="photo-gradient"></div>
      <div class="photo-vignette"></div>
      <div class="photo-color-grade"></div>
      <div class="welcome-overlay">
        <h1 class="welcome-greeting">
          {{ greeting$ | async }}
        </h1>
        <p class="welcome-subtitle">Welcome to your InterVal valuation platform</p>
      </div>
    </div>
  </div>

  <div class="form-panel">
    <div class="form-container">
      <div class="logo-container awaiting-morph" id="logoContainer" role="img" aria-label="Hamptons International">
        <img class="logo logo-english" id="logoEnglish" src="assets/media/hamptons/Logo-english-primary.svg" alt="">
        <img class="logo logo-arabic" id="logoArabic" src="assets/media/hamptons/Logo-arabic-primary.svg" alt="">
      </div>
      <div id="login-embed"></div>
      <div class="powered-by">
        Powered by <a href="https://interval-soft.com" target="_blank" rel="noopener">InterVal</a>
      </div>
    </div>
  </div>
</div>